export const STATS_FEATURE_FILTERS = [
  { id: "all", label: "Tous" },
  { id: "lunishower", label: "LuniShower" },
  { id: "greenmiles", label: "GreenMiles" },
];

export const FEATURE_STATUS_DEFINITIONS = [
  { value: "LIVE", label: "LIVE" },
  { value: "PAS_EQUIPE", label: "Pas équipé" },
  { value: "DESEQUIPE", label: "Déséquipé" },
  { value: "OFF", label: "OFF" },
  { value: "__NONE__", label: "Non défini" },
];

const STATUS_VALUE_SET = new Set(FEATURE_STATUS_DEFINITIONS.map((s) => s.value));

export const normalizeFeatureStatusValue = (status) =>
  status && STATUS_VALUE_SET.has(status) ? status : "__NONE__";

export const getHotelFeatureStatus = (hotel, featureId) => {
  if (featureId === "lunishower") {
    return normalizeFeatureStatusValue(hotel.lunishower_status);
  }
  if (featureId === "greenmiles") {
    return normalizeFeatureStatusValue(hotel.greenmiles_status);
  }
  return "__NONE__";
};

export const hotelHasFeature = (hotel, featureId) => {
  if (featureId === "lunishower") {
    return Boolean(hotel.has_lunishower);
  }
  if (featureId === "greenmiles") {
    return Boolean(hotel.has_greenmiles);
  }
  return true;
};

export const getAvailableFeatureStatuses = (hotels, featureId) => {
  if (featureId === "all") {
    return [];
  }

  const counts = hotels.reduce((acc, hotel) => {
    if (!hotelHasFeature(hotel, featureId)) {
      return acc;
    }
    const key = getHotelFeatureStatus(hotel, featureId);
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  return FEATURE_STATUS_DEFINITIONS.map((def) => ({
    ...def,
    count: counts[def.value] || 0,
  })).filter((def) => def.count > 0 || def.value !== "__NONE__");
};

export const getAllFeatureStatusValues = (hotels, featureId) => {
  const values = new Set(FEATURE_STATUS_DEFINITIONS.map((s) => s.value));
  hotels.forEach((hotel) => {
    if (hotelHasFeature(hotel, featureId)) {
      values.add(getHotelFeatureStatus(hotel, featureId));
    }
  });
  return Array.from(values);
};

export const filterHotelsByFeature = (hotels, featureId, selectedStatuses) => {
  if (featureId === "all") {
    return hotels;
  }

  if (!selectedStatuses?.length) {
    return [];
  }

  return hotels.filter((hotel) => {
    if (!hotelHasFeature(hotel, featureId)) {
      return false;
    }
    return selectedStatuses.includes(getHotelFeatureStatus(hotel, featureId));
  });
};

export const mapHomeListHotelForStats = (hotel) => ({
  hId: hotel.id,
  hName: hotel.name,
  has_lunishower: hotel.has_lunishower,
  has_greenmiles: hotel.has_greenmiles,
  lunishower_status: hotel.lunishower_status,
  greenmiles_status: hotel.greenmiles_status,
});
